export const SEARCH_BAR_TYPED = 'SEARCH_BAR_TYPED';
